import AppsOutageIcon from '@mui/icons-material/AppsOutage'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

import './notFound.scss'

const NotFound = () => (
  <Stack className='not-found'>
    <Typography variant='h4' gutterBottom color='primary'>Not Found</Typography>
    <AppsOutageIcon color='primary' sx={{fontSize: '200px'}} />
    <Box>
      <Typography color='secondary' variant='body1' gutterBottom>
        Oops, it seems like we do not have the route you are looking for.
      </Typography>
    </Box>
  </Stack>
)

export default NotFound
